module.exports = __webpack_public_path__ + "static/xmasjumper-0d6ce44f9184d3cd446f6114b066c20f.jpeg";